// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falBars: CreateIconOptions = {
  "displayName": "FALBars",
  "viewBox": "0, 0, 448, 512",
  "d": "M0 80c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 96C7.2 96 0 88.8 0 80zM0 240c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 256c-8.8 0-16-7.2-16-16zM448 400c0 8.8-7.2 16-16 16L16 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0c8.8 0 16 7.2 16 16z"
};
